import React from 'react';
import { AiOutlineForm } from 'react-icons/ai';

const Desistimiento = () => {
    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Desistimiento</h1>

                <p className='text-xl font-sans text-center'>
                El desistimiento es el acto jurídico procesal por el que, a solicitud de una de las partes, se eliminan los efectos jurídicos de un proceso, de algún acto jurídico procesal realizado en su interior, o de la pretensión procesal.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Desistimientos.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>
            </div>
        </div>
    );
}

export default Desistimiento;